module.exports = __webpack_public_path__ + "static/img/user_icon.6991be4d.jpg";